import React, { useState, useEffect, useContext } from 'react';
// design
import { Table, Space, Button, Upload, message, Popconfirm } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
// method
import { getMethod, delMethod } from '../services/methods';
// utils
import {dateFormat} from '../utils/dateFormat';
// context
import { GlobalContext } from "../context/globalContext";

export default function Persons() {
    // context
    const { contextData, dispatch } = useContext(GlobalContext);
    const [loading, setLoading] = useState(true);

    const uploadPersonProps = {
        name: 'person',
        action: `${process.env.REACT_APP_API_PATH}/upload/person`,
        accept: '.xlsx',
        headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        onChange(info) {
            if (info.file.status === 'done') {
                setTimeout(() => {
                    message.success(`${info.file.name} dosya yükleme başarılı.`);
                    fetchData();
                }, 3000);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} dosya yüklenirken bir hata oluştu.`);
            }
        },
    };

    const [data, setData] = useState(null);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 20,
        total: 0,
    });

    const handleTableChange = async (paginationChange) => {
        setLoading(true)
        const userData = await getMethod(`/person/${paginationChange.pageSize}/${paginationChange.pageSize * (paginationChange.current - 1)
            }`);
        setData(userData.list)
        setPagination(paginationChange);
        setLoading(false)
    };

    const fetchData = async () => {
        setLoading(true)
        const userData = await getMethod(`/person/${pagination.pageSize}/${pagination.pageSize * (pagination.current - 1)
            }`);
        setData(userData.list)
        setPagination({
            ...pagination,
            total: userData?.count,
        });
        setLoading(false)
    }

    useEffect(() => {
        fetchData();
    }, [])

    const onDelete = async (id) => {
        await delMethod("/person", id);
        fetchData();
    }

    useEffect(() => {
        fetchData();
    }, [])

    const columns = [
        {
            title: 'Doğum günü',
            dataIndex: 'birthday',
            key: 'birthday',
            width: '120px',
            render: (value, row, index) => {
                const date = dateFormat(value);
                return date;
            },
        },
        {
            title: 'Ad',
            dataIndex: 'name',
            key: 'name',
            width: "120px"
        },
        {
            title: 'Soyad',
            dataIndex: 'surname',
            key: 'surname',
            width: "120px"
        },
        {
            title: 'Tel',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'İl',
            dataIndex: 'state',
            key: 'state',
            width: "100px"
        },
        {
            title: 'İlçe',
            dataIndex: 'county',
            key: 'county',
            width: "100px"
        },
        {
            title: 'Mahalle',
            dataIndex: 'district',
            key: 'district',
            width: "100px"
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Aksiyon',
            key: 'action',
            width: "90px",
            render: (text, record) => {
                if(record?.engagement.length === 0 || !["admin"].includes(contextData.userData.role)) return null;

                return <Space size="middle">
                    <Popconfirm title="Silme işlemini onayla" onConfirm={() => onDelete(text._id)}>
                        <a>Sil</a>
                    </Popconfirm>
                </Space>
            },
        },
    ];

    if (!["admin", "admin-center"].includes(contextData.userData.role)) {
        return false;
    }

    return (
        <>
            {["admin"].includes(contextData.userData.role) && <div style={{ marginBottom: "16px" }}>
                <Upload {...uploadPersonProps}>
                    <Button
                        icon={<UploadOutlined />}>
                        Kişi listesini aktar
                    </Button>
                </Upload>
            </div>}
            <Table
                scroll={{ y: window.innerHeight - 315 }}
                loading={loading}
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={data}
                pagination={pagination}
                onChange={handleTableChange}
            />

        </>
    )
}
